<template>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link
    href="https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap"
    rel="stylesheet">
  <div v-show="!showAlertForSmallScreen" id="nav">
    <span class="logo">
      <a href="/" style="text-decoration: none;"><h1 style="color: white">AGES</h1></a>
    </span>
    <div v-if="$route.path !== '/'" class="enginesmallbox">
      <engine class="engine-small" />
    </div>
    <span>
      <!-- <router-link class="navlink home" to="/">Home</router-link> -->
      <router-link class="navlink faq" to="/FAQ">FAQ</router-link>
      <router-link class="navlink about" to="/about">About</router-link>
      <router-link class="navlink contact" to="/contact">Contact</router-link>
      <!-- <span v-if="!hasLogined()" @click="showLoginForm" class="navlink">Login</span> -->
      <!-- <span v-if="hasLogined()" @click="logOut()" class="navlink">Logout</span> -->
    </span>
  </div>
  <router-view />
</template>

<script>
import Engine from "@/components/Engine.vue";
import Swal from 'sweetalert2';
import axios from "axios";
import { isValidToken } from "@/utils/login.js"
import { smallScreenMixin } from '@/mixins/smallScreenMixin';


export default {
  name: "SearchAutocomplete",
  mixins: [smallScreenMixin],
  components: {
    Engine,
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      if (window.innerWidth < 1010) {
        this.showAlertForSmallScreen = true;
      } else {
        this.showAlertForSmallScreen = false;
      }
    },
    hasLogined() {
      return isValidToken(localStorage.getItem('ages_hms_access_token'))
    },
    logOut() {
      if (localStorage.getItem('ages_hms_access_token')) {
        localStorage.removeItem('ages_hms_access_token');
      }
      this.$router.go(0);
    },
    showLoginForm() {
      let usernameInput
      let passwordInput
      Swal.fire({
        title: '<h3 style="font-family: Ubuntu; font-size: 24px;">HMS Student Login</h3><p style="font-family: Ubuntu; margin-top: 5px;font-size: 13px;">Contact Your Supervisor For Granting Access</p>',
        html: `
          <input style="font-family: Ubuntu; font-size: 18px !important;" type="text" name="username" id="username" class="swal2-input" placeholder="Username" autocomplete="on">
          <input style="font-family: Ubuntu; font-size: 18px !important;" type="password" name="password" id="password" class="swal2-input" placeholder="Password" autocomplete="on">
        `,
        iconColor: '#A51C30',
        confirmButtonText: `<h3 style="font-family: Ubuntu;">Login<h3>`,
        confirmButtonColor: "#A51C30",
        focusConfirm: false,
        didOpen: () => {
          const popup = Swal.getPopup()
          usernameInput = popup.querySelector('#username')
          passwordInput = popup.querySelector('#password')
          usernameInput.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
          passwordInput.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
        },
        preConfirm: async () => {
          const username = usernameInput.value
          const password = passwordInput.value
          if (!username || !password) {
            Swal.showValidationMessage(`<h5 style="font-family: Ubuntu;">Please Enter Username & Password<h5>`)
          } else {
            try {
              const response = await axios.post(
                `${process.env.VUE_APP_ROOT_API}/api/generate_token`,
                {
                  username: username,
                  password: password
                }
              );
              localStorage.setItem('ages_hms_access_token', response.data.access_token);
              this.$router.go(0);
            } catch (error) {
              Swal.showValidationMessage(`<h5 style="font-family: Ubuntu;">Incorrect Username / Password<h5>`);
            }
          }
        },
      })
    },
  },
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  --scrollbarBG: #cfd8dc;
  --thumbBG: #90a4ae;
}

#app {
  font-family: Ubuntu;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0f2132;
}

#nav {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: left;
}

#nav img {
  width: 30px
}

.logo {
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-radius: 5px;
  padding-right: 7px;
}

#nav h3 {
  font-size: 1.4rem;
  color: white;
  background-color: transparent;
  padding: 5px 10px;
  height: 40px;
  border-radius: 5px;
}

#nav {
  background-color: #1E1E1E;
  padding: 12px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
  max-height: 60px;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 9999;
}

#nav .navlink {
  color: white;
  font-weight: bold;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 10px;
  height: 35px;
  position: absolute;
  top: 13px;
  border-radius: 5px;
  margin-left: 20px;
  cursor: pointer;
}

#nav .faq {
  right: 20px;
}


#nav .about {
  right: 165px;
}

#nav .contact {
  right: 80px;;
}

#nav .navlink:hover {
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.7);
  transition: 150ms;
}

.engine-area>* {
  font-size: 10px !important;
  width: 410px;
  margin-left: 2rem;
  position: relative;
  right: 0;
}
</style>
